import { Connector } from '../../../../../api/connector'
import { ServerlessApiAccount } from '../shared'

export interface GetServerlessAccountsArgs {
  organizationUuid?: string
}
export interface GetServerlessAccountsResponse {
  data: {
    accounts: ServerlessApiAccount[]
  }
}

export async function getServerlessAccounts(
  this: { connector: Connector },
  { organizationUuid }: GetServerlessAccountsArgs
) {
  const {
    data: { accounts }
  } = await this.connector.get<GetServerlessAccountsResponse>(
    `/serverless/organizations/${organizationUuid}/accounts`
  )
  return accounts
}
